import DOMPurify from 'dompurify';

type Props = {
    html: string | null | undefined;
    className?: string;
};

export const SafeHtml = ({ html, className }: Props) => {
    if (!html) return null;
    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
        />
    );
};
